import HcpClinicalInformation from "@/page-components-hcp/clinical-information";

export default function HcpClinicalInformationPage() {
  
  return <HcpClinicalInformation />;
}

// Forward layout props to `_app` so it can wrap with the proper layout
HcpClinicalInformationPage.getLayoutProps = (pageProps, router) => (
  typeof HcpClinicalInformation.getLayoutProps === 'function'
    ? HcpClinicalInformation.getLayoutProps(pageProps, router)
    : {}
);